import React, { Component } from 'react'
import { Table, IconButton, Dialog, Button } from 'react-toolbox'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import Input from 'components/fulcrum/input/RangeInput'
import MemoryConfigItem from './MemoryConfigItem'

import styles from './styles.scss'

class MemoryConfig extends Component {
  constructor(props) {
    super(props)

    this.allParts = []
  }

  onClockChange(config) {
    return value => this.props.onClockChange(config, value)
  }

/**
 *
 * Generates a memory for a memory configuration
 *
 * @param {any} curValue
 * @memberof MemoryConfig
 * @returns {Object} a memory item
 */
  generateMemoryConfig(curValue) {
    const clockInputHint = `Enter a number between ${curValue.minClock} and ${curValue.maxClock}`
    const memoryItem = {
      type: curValue.partType,
      organization: `${curValue.organizationSize}Mx${curValue.organizationWidth}`,
      density: `${curValue.density}GB`,
      clock: <Input
                label='Clock'
                hint={clockInputHint}
                min={curValue.minClock}
                max={curValue.maxClock}
                value={curValue.clock}
                onChange={this.onClockChange(_.pick(curValue, [
                  'partType',
                  'density',
                  'organizationSize',
                  'organizationWidth',
                  'channel',
                ]))}
                required
              />,
    }

    return memoryItem
  }

/**
 *
 * Generates an array of all memory of some configuration
 *
 * @returns {Array} an array memory items
 * @memberof MemoryConfig
 */
  generateMemoryConfigs() {
    this.allParts = this.props.values

    // generate every configuration using the first part in the configuration
    return this.allParts.map(config => this.generateMemoryConfig(config[0]))
  }

  getExistConfigs() {
    return this.props.values.map(value => value[0].config)
  }

  onAddPart(partConfig = {}) {
    const {
      initConfigFilter,
      setIsAddPart,
      onTogglePopup,
      onUpdateCurConfig,
    } = this.props

    return () => {
      initConfigFilter(this.getExistConfigs())
      setIsAddPart(false)
      onTogglePopup()
      onUpdateCurConfig(partConfig)
    }
  }

  render() {

    const memoryConfigs = this.generateMemoryConfigs()

    const {
      values,
      curConfig,
      filterPairs,
      initFilters,
      onClockChange,
      onDeletePart,
      onTogglePopup,
      onUpdateCurConfig,
      setIsAddPart,
    } = this.props

    return <div>
      { memoryConfigs.map((config, index) => {
        const curPart = this.allParts[index]
        return <MemoryConfigItem
                  key={index}
                  config={config}
                  index={index}
                  curPart={curPart}
                  curValues={values[index]}
                  curValue={values[index][0]}
                  onClockChange={onClockChange}
                  onDeletePart={onDeletePart}
                  onTogglePopup={onTogglePopup}
                  onUpdateCurConfig={onUpdateCurConfig}
                  curConfig={curConfig}
                  filterPairs={filterPairs}
                  initFilters={initFilters}
                  setIsAddPart={setIsAddPart}
                />
      }) }
      <Button
        icon='add'
        label='ADD CONFIGURATION(S)'
        flat
        primary
        onClick={ this.onAddPart() }
        styleName="universeAddBtn"
        theme={styles}
      />
    </div>
  }
}

MemoryConfig.propTypes = {
  values: PropTypes.array.isRequired,
  togglePopup: PropTypes.bool.isRequired,

  initFilters: PropTypes.func.isRequired,
  onClockChange: PropTypes.func.isRequired,
  onTogglePopup: PropTypes.func.isRequired,
  onDeletePart: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(MemoryConfig, styles)
